<template>
  <component
    :is="tag"
    :disabled="disabled"
    class="c-button-count"
    :class="{ '-disabled': disabled }"
    @click="emitClickEvent"
  >
    <span class="c-button-count__inner">
      <template v-if="kind === 'plus'">
        <IconBase>
          <path
            d="M13.043 10.8477H17.8008V12.8984H13.043V18.2891H10.8633V12.8984H6.10547V10.8477H10.8633V5.86719H13.043V10.8477Z"
          />
        </IconBase>
      </template>
      <template v-else-if="kind === 'minus'">
        <IconBase>
          <path d="M16.8984 12.3711H7.11328V10.6016H16.8984V12.3711Z" />
        </IconBase>
      </template>
    </span>
  </component>
</template>

<script lang="ts">
import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props:{
    tag: { type: String, required: false, default: "button" },
    kind: { type: String, required: false, default: "plus" },
    disabled: { type: Boolean, required: false, default: false }
  },
  components: {
    IconBase
  }
})
export default class ButtonCount extends Vue {
  tag!: string;
  kind!: string;
  disabled!: boolean;

  emitClickEvent() {
    this.$emit("click-button");
  }
}
</script>

<style lang="scss" scoped>
.c-button-count {
  color: $common-white;
  text-align: center;
  margin-left: rem(-6);
  margin-right: rem(-6);
  padding: rem(6);
  display: block;
  touch-action: manipulation;

  @include sp {
    margin-left: rem(-12);
    margin-right: rem(-12);
    padding: rem(12);
  }

  &__inner {
    height: rem(24);
    width: rem(24);
    border-radius: px(4);
    background: $common-gray-btn;
    display: block;
  }
  &.-disabled &__inner {
    background: $common-gray300;
  }

  &.-disabled {
    &:focus {
      &__inner {
        background-color: $common-gray300;
      }
    }
  }
}
</style>
